import React, { createContext, useContext } from 'react';
import type { MapEngineContext } from '../../types/mapEngine';

const Ctx = createContext<MapEngineContext | null>(null);

export const MapEngineProvider = Ctx.Provider;

export function useMapEngine(): MapEngineContext {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error('useMapEngine must be used inside <UnifiedAirportMap>');
  return ctx;
}
